import { FC } from 'react';
import LayOutPageLefts from './lefts';
import LayOutPageLeftItem from './leftItem';
import LayOutPageLeftPage from './page';
import {
  LayOutPageLeftsProps,
  LayOutPageLeftItemProps,
  LayOutPageLeftPageProps,
} from '../interface';

export type ILayOutPageLeftsComponent = FC<LayOutPageLeftsProps> & {
  Item: FC<LayOutPageLeftItemProps>;
  Page: FC<LayOutPageLeftPageProps>;
};

const TransLayOutLeftsPage = LayOutPageLefts as ILayOutPageLeftsComponent;
TransLayOutLeftsPage.Item = LayOutPageLeftItem;
TransLayOutLeftsPage.Page = LayOutPageLeftPage;

export default TransLayOutLeftsPage;
